import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import ProtectedRoute from "@/components/ProtectedRoute";
import InstallPwaPrompt from "@/components/InstallPwaPrompt";
import LoginPage from "@/pages/LoginPage";
import RegisterPage from "@/pages/RegisterPage";
import DashboardPage from "@/pages/DashboardPage";
import CareProgramPage from "@/pages/CareProgramPage";
import AdminPage from "@/pages/AdminPage";
import AnalysisPage from "@/pages/AnalysisPage";
import PatientsAdminPage from "@/pages/PatientsAdminPage";
import DialysisSummaryPage from "@/pages/DialysisSummaryPage";
import GastrostomySummaryPage from "@/pages/GastrostomySummaryPage";

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Navigate to="/dashboard" replace />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/register" element={<RegisterPage />} />
          <Route
            path="/dashboard"
            element={
              <ProtectedRoute>
                <DashboardPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/programs/:id"
            element={
              <ProtectedRoute>
                <CareProgramPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/admin"
            element={
              <ProtectedRoute adminOnly>
                <AdminPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/analisis"
            element={
              <ProtectedRoute adminOnly>
                <AnalysisPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/pacientes"
            element={
              <ProtectedRoute adminOnly>
                <PatientsAdminPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/dialisis"
            element={
              <ProtectedRoute adminOnly>
                <DialysisSummaryPage />
              </ProtectedRoute>
            }
          />
          <Route
            path="/gastrostomia"
            element={
              <ProtectedRoute adminOnly>
                <GastrostomySummaryPage />
              </ProtectedRoute>
            }
          />
          <Route path="*" element={<Navigate to="/dashboard" replace />} />
        </Routes>
        <InstallPwaPrompt />
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </AuthProvider>
  );
}

export default App;
